<template>
  <div class="form-container" id="confirm">
    <div v-show="loading">
      <vue-loading type="spiningDubbles" color="#008FDE" :size="{ width: '50px', height: '50px'}"></vue-loading>
    </div>
    <div v-show="!loading">
      <div class="sectionHeader" v-html=this.lblHeader></div>
      <div class="sectionheader" ><p v-html=this.lblMessage1></p></div>
      <form @submit.prevent="exec">
        <div class="form-group">
          <div class="form-label">
            <label for="inputAuthCode">{{ $t('onetime-auth.lblAuthCode') }}</label>
          </div>
          <input
            v-model="form.authCode"
            type="text"
            class="form-control"
            id="inputAuthCode"
            :placeholder="$t('onetime-auth.placeholderAuthCode')"
            maxlength="4"
            required
            autocomplete="one-time-code">
        </div>
        <div slot="footer" class="message">
          {{message}}
        </div>
        <div slot="footer" class="validMsg" v-html=errorMessage>
        </div>
        <div class="sectionheader" v-html=this.lblMessage2></div>
        <div class="btn-container">
          <button type="submit" class="btn btn-primary"
            v-bind:class="{ 'btn-disabled': isDisabled}"
            v-bind:disabled="isDisabled"      
          >{{ $t('app.btnAuthentication') }}</button>
        </div>
      </form>
      <div class="sectionheader" v-html=this.lblMessage3></div>
      <div class="link-container">
        <router-link :to="{ path:'onetime-input', query: $route.query}">{{$t('app.btnPrev')}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { smsCodeAuthentication ,formMessage } from '@/lib/api/commb-api'
import { VueLoading } from 'vue-loading-template'
export default {
  name: 'onetimeauth',
  data: function () {
    return {
      form: {
        authCode: ''
      },
      formId:'onetime-auth',
      qq: {} ,
      lblHeader:'',
      lblMessage1:'',
      lblMessage2:'',
      lblMessage3:'',
      lblMessage4:'',
      message: '',
      errorMessage: '',
      isDisabled: false,
      loading:true,
    }
  },
  async created() {
    this.loading = true
    this.paramValidate();
    const lang = ['ja', 'en'].includes(this.$route.query.lang) ? this.$route.query.lang : 'ja'
    this.$i18n.locale = lang
    const smsAuthId = this.$root.$data.smsAuthId
    if(!smsAuthId){
      this.$router.push({ path: 'onetime-input' , query: this.$route.query })
    }

    const appType = this.qq['APPTYPE']
    const srvType = this.qq['SRVTYPE']
    const res = await formMessage(this.formId, appType, srvType, lang)
    for(let messageContent of res.messagelist){
      if(messageContent.areaType === '0'){
        this.lblHeader = messageContent.message
      }else if(messageContent.areaType === '1'){
        this.lblMessage1 = messageContent.message
      }else if(messageContent.areaType === '2'){
        this.lblMessage2 = messageContent.message
      }else if(messageContent.areaType === '3'){
        this.lblMessage3 = messageContent.message
      }
    }
    this.loading = false
  },
  components: {
    VueLoading
  },
  methods: {
    paramValidate() {
      const qp = this.$route.query;
      const excludeQueryParam = [];
      for (const [key, value] of Object.entries(qp)) {
        if(!excludeQueryParam.includes(key.toUpperCase())){
          this.qq[key.toUpperCase()] = value;
        }
      }
    },
    async exec () {
      this.isDisabled = true;
      const { authCode } = this.form;
      this.message = '';
      this.errorMessage = '';
      const smsAuthId = this.$root.$data.smsAuthId

      try{
        const res = await smsCodeAuthentication(authCode, smsAuthId, this.qq['LANG'] || 'ja')
        this.$root.$data.idToken = res.IDToken
        this.$router.push({ path: 'authenticated' , query: this.$route.query })
      }catch(err){
        this.errorMessage = err ? err : this.$i18n.t('app.errorMessage');
      }
      this.isDisabled = false;
    }
  }
}
</script>